import { A9Component, ComponentController } from 'components/system';

import template from './visual.molecules.select-editor.component.html';
import './styles.less';

export const EMPTY_KEY = -1;

@A9Component({
    selector: 'vi-molecule-select-editor',
    scope: {
        resource: '<',
        ngModel: '=',
        dictKey: '@?',
        dictName: '@?',
        itemTemplate: '@?',
        hasCustom: '<?',
        customName: '@?',
        customObject: '=?',
        hideEdit: '@?',
        hideTemplateForCaption: '@?',
        loading: '=?',
        readonly: '<',
        onEdit: '&',
        onReady: '&'
    },
    replace: true,
    template() {
        return template;
    }
})
export class VisualMoleculesSelectEditorComponent extends ComponentController {
    private ids;
    private unwatchers;
    private cachedModel;
    private customNameWatcher;

    constructor(
        protected $scope,
        private dialogManager,
        private $timeout
    ) {
        super($scope);

        this.initScope();
        this.run();
    }

    load() {
        const $scope = this.$scope;
        $scope.loading = true;
        $scope.resource.reload();
    }

    prepareItem(item) {
        return item;
    }

    prepareList(list) {
        return list;
    }

    get dictKey() {
        const $scope = this.$scope;
        return $scope.dictKey || 'id';
    }

    get dictName() {
        const $scope = this.$scope;
        return $scope.dictName || 'name';
    }

    private initScope() {
        const $scope = this.$scope,
            resource = $scope.resource,
            $timeout = this.$timeout;

        this.load();

        this.ids = [];

        resource.onLoaded(items => {
            // console.log('Loaded: ', angular.copy(items));
            items = this.prepareList(items);
            this.dataUpdate(items);
            if (this.unwatchers) {
                this.unwatchers.forEach(_unw => _unw());
            }
            this.unwatchers = [];

            const unw1 = $scope.$watch('hasCustom', () => {
                $timeout(() => this.updateCustom());
            });
            this.unwatchers.push(unw1);

            const unw2 = $scope.$watch(
                () => JSON.stringify($scope.customObject),
                () => {
                    $timeout(() => this.updateCustom());
                }
            );
            this.unwatchers.push(unw2);

            this.ids = items.map(_i => _i[this.dictKey]);
            this.updateId();
        });
        resource.onFail(this.dataError.bind(this));
        resource.onUpdated(() => {
            this.load();
        });

        $scope.$watch('ngModel', this.updateId.bind(this));
        $scope.$watch('id', this.updateModel.bind(this));
    }

    private dataUpdate(items) {
        const $scope = this.$scope;
        $scope.loading = false;

        // console.log('Data Update: ', angular.copy(items) );

        $scope.dict = items.map(item => ({
            key: item[this.dictKey],
            name: item[this.dictName],
            entity: this.prepareItem(item)
        }));
    }

    private updateCustom() {
        const $scope = this.$scope;
        const hasCustom = $scope.hasCustom;
        this.cachedModel = $scope.ngModel;
        this.removeCustom();
        if (hasCustom) {
            this.addCustom();
        }
    }

    private removeCustom() {
        const $scope = this.$scope;

        const emptyIndex = $scope.dict.findIndex(_i => _i.key === null);
        if (emptyIndex != -1) {
            $scope.dict.splice(emptyIndex, 1);
        }
    }

    private addCustom() {
        const $scope = this.$scope;

        const empty = $scope.dict.find(_i => _i.key === EMPTY_KEY);
        if (!empty) {
            if (this.customNameWatcher) {
                this.customNameWatcher();
            }

            const newEmpty = {
                key: EMPTY_KEY,
                name: $scope.customName,
                entity: this.prepareItem($scope.customObject)
            };
            $scope.dict.unshift(newEmpty);

            this.customNameWatcher = $scope.$watch('customName', customName => {
                newEmpty.name = customName;
            });
        }
    }

    private updateId() {
        const $scope = this.$scope;

        if (this.ids.length) {
            $scope.id = this.ids.indexOf($scope.ngModel) != -1 ? $scope.ngModel : EMPTY_KEY;
        }
    }

    private dataError(message) {
        this.dialogManager.error(message);
    }

    private updateModel() {
        const $scope = this.$scope;
        if ($scope.id) {
            $scope.ngModel = $scope.id;
        }
    }
}
